import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';

import useCurrentUserPermissions from '../hooks/useCurrentUserPermissions';
import { getHomeRoute } from '../utils/userType';

const ATS_LITE_RESTRICTED_ROUTES = ['/data/', '/prospectlist', '/talent-marketplace'];

const ATSRoute: React.FC<RouteProps> = (props) => {
  const { isPostingOnly, isAtsLiteDistrict, userType, hasApplications } =
    useCurrentUserPermissions();
  const location = useLocation();

  // requireATS logic
  if (isPostingOnly) {
    return <Redirect to="/district/jobslist" />;
  }

  if (isAtsLiteDistrict) {
    const isRestrictedRoute = ATS_LITE_RESTRICTED_ROUTES.some((route) =>
      location.pathname.startsWith(route)
    );

    if (isRestrictedRoute) {
      const homeRoute = getHomeRoute({ userType, hasApplications });
      return <Redirect to={homeRoute} />;
    }
  }

  return <Route {...props} />;
};

export default ATSRoute;
